<template>
  <div>
    <div class="custom-card-header">
      <!-- <div class="filterButtonPosition">
        <f7-button
          fill
          class="whiteFontColor button-filter"
          panel-toggle="right"
        >
          <span class="ic-filter"></span> {{ $t('filter') }}
        </f7-button>
      </div> -->
    </div>
    <DxDataGrid
      :data-source="store"
      :show-borders="false"
      :show-column-lines="false"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :show-colon="false"
      :remote-operations="true"
      :hover-state-enabled="false"
      :show-row-lines="false"
      :row-alternation-enabled="false"
      class="custom-grid"
      :auto-navigate-to-focused-row="autoFocus"
      @contentReady="init"
      @focused-row-changed="focusedRowChanged"
      @toolbar-preparing="onToolbarPreparing($event)"
    >
      <DxScrolling mode="standard" />
      <DxStateStoring
        :enabled="true"
        type="localStorage"
        storage-key="alertsReportsSampleTable"
      />
      <DxPaging :page-size="10" />
      <DxPager
        :show-page-size-selector="true"
        :allowed-page-sizes="[5, 10, 20]"
        :show-info="true"
        info-text="{2} items"
        :visible="true"
      />

      <DxSearchPanel
        :visible="true"
        :width="300"
        :placeholder="$t('search')"
      />

      <DxColumn
        data-field="atc"
        :caption="$t('alert.area')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_code"
        name="sample_code"
        :caption="$t('agronomySample.summary.sampleCode')"
        alignment="left"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="sample_type"
        :caption="$t('agronomySample.summary.sampleType')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="farm"
        :caption="$t('foodSamples.samplingSite')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="parcel"
        :caption="$t('environmentSamples.samplingPoint')"
        alignment="left"
        :allow-header-filtering="false"
      />
      <DxColumn
        data-field="created_at"
        :caption="$t('alert.creationDate')"
        alignment="left"
        data-type="date"
        :format="$helpers.getDateFormat(company)"
        :allow-header-filtering="false"
      />

      <DxColumn
        data-field="parameters"
        :caption="$t('alert.parameters')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateParams"
      />
      <DxColumn
        data-field="parameters"
        :caption="$t('reports.exceededLimits')"
        alignment="left"
        name="limits"
        :allow-header-filtering="false"
        cell-template="cellTemplateLimits"
      />
      <DxColumn
        data-field=""
        :caption="$t('unfulfilledChains')"
        alignment="left"
        :allow-header-filtering="false"
        cell-template="cellTemplateChains"
      />

      <DxColumn
        :buttons="editButtons"
        :fixed="true"
        fixed-position="right"
        type="buttons"
      />

      <template #cellTemplateParams="{ data }">
        <div style="min-width: 100px">
          {{
            data.value.flatMap((param) => param.parameter).toString()
          }}
        </div>
      </template>

      <template #cellTemplateLimits="{ data }">
        <div style="min-width: 100px">
          {{
            getCountryFullName(
              data.value[0].cma_value !== null
                ? 'CMA'
                : data.value
                    .flatMap((param) => param.lmrs)
                    .flatMap((lmr) => lmr.country_code)
                    .filter((v, i, a) => a.indexOf(v) == i)
                    .toString()
            )
          }}
        </div>
      </template>
      <template #cellTemplateChains="{ data }">
        <div>
          <div v-if="data.data.retailers">
            {{ data.data.retailers.toString() }}
          </div>
          <div v-else></div>
        </div>
      </template>
    </DxDataGrid>

    <SampleDetailsPopup v-if="showReportPopup" :details="details" />
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';

import { mapActions, mapState } from 'vuex';

import notify from 'devextreme/ui/notify';
import SampleDetailsPopup from '@/components/Alerts/Reports/DetailsPopup/Sample/index.vue';
import EventBus from '@/services/event-bus';
import Helpers from '@/js/helpers';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import countryTranslationServiceEs from '@/i18n/translated_countries_service_es';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import iconTrash from '@/static/icons/ic_trash_new.svg';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    SampleDetailsPopup,
  },
  props: {
    store: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editButtons: [
        {
          icon: iconVisibility,
          cssClass: 'grid-button-icon',
          onClick: this.showDetails,
        },
        {
          icon: iconTrash,
          cssClass: 'grid-button-icon',
          onClick: this.delete,
        },
      ],
    };
  },
  computed: {
    autoFocus() {
      return Helpers.isEmptyObject(this.params);
    },
    ...mapState('contact', ['company']),
    ...mapState('alertsSample', [
      'showReportPopup',
      'focusedReportRowKey',
    ]),
  },
  methods: {
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };
      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      // Añadir el selector de agrupaciones
      toolbarItems.push({
        name: 'Filtros',
        location: 'before',
        widget: 'dxButton',
        locateInMenu: 'never',
        options: {
          text: this.$t('filter'),
          icon: '././static/icons/ic_filter.svg',
          width: 115,
          elementAttr: {
            class: 'btn-filtrar',
          },
          onClick: () => {
            this.$f7.panel.open('right');
          },
        },
      });

      // Boton para Filtrar En alerta
      // toolbarItems.push({
      //   name: 'En alerta',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'En alerta',
      //     width: 95,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Sin revisar
      // toolbarItems.push({
      //   name: 'Sin revisar',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Sin revisar',
      //     width: 105,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Sin positivos
      // toolbarItems.push({
      //   name: 'Sin positivos',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Sin positivos',
      //     width: 118,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar En proceso
      // toolbarItems.push({
      //   name: 'En proceso',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'En proceso',
      //     width: 110,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Terminada
      // toolbarItems.push({
      //   name: 'Terminada',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Terminada',
      //     width: 105,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Recibida
      // toolbarItems.push({
      //   name: 'Recibida',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Recibida',
      //     width: 95,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });

      // // Boton para Filtrar Último mes
      // toolbarItems.push({
      //   name: 'Último mes',
      //   location: 'before',
      //   widget: 'dxButton',
      //   locateInMenu: 'never',
      //   options: {
      //     text: 'Último mes',
      //     width: 115,
      //     elementAttr: {
      //       class: 'filtrosBotones',
      //     },
      //     onClick: () => {
      //       console.log('Botón Filtrar presionado');
      //     },
      //   },
      // });
    },
    getCountryFullName(code) {
      return countryTranslationServiceEs.getCountryNameByCode(code);
    },
    init(e) {
      e.component.option('focusedRowKey', this.focusedReportRowKey);
      this.changedFocused = true;
    },
    focusedRowChanged(row) {
      if (!row.row) return;

      if (this.changedFocused) {
        if (Helpers.isEmptyObject(this.params)) {
          this.setReportFocusedRowKey(row.row.data.id);
        }
      }
    },
    applyFramework7DialogTexts() {
      if (!this.$f7) return;

      this.$f7.params.dialog.buttonCancel = this.$t('cancel');
      this.$f7.params.dialog.buttonOk = this.$t('samplesRegister.ok');
    },
    delete(data) {
      this.applyFramework7DialogTexts();
      this.$f7.dialog.confirm(
        `${this.$t('reports.deleteConfirm')}`,
        async () => {
          const { id } = data.row.data;

          try {
            notify(
              {
                message: this.$t('reports.deleting'),
                width: 450,
              },
              'info',
              2000
            );

            await this.deleteAlertReport(id);

            notify(
              {
                closeOnClick: true,
                message: this.$t('reports.deleted'),
                width: 450,
              },
              'success',
              2000
            );

            EventBus.$emit('AlertsSampleReportsPage', this.params);

            this.$f7.dialog.close();
          } catch (error) {
            this.$notifyDX(
              {
                message: this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    JSON.parse(error.message).error
                  )
                ),
                width: 550,
              },
              'error',
              NOTIFY_TIME_LONG
            );
          }
        }
      );
    },
    showDetails(e) {
      const { data } = e.row;
      this.details = data;

      this.$f7router.navigate('/alerts/sample/reports/details', {
        props: { details: data },
      });
      // this.setShowReportPopup(true);
    },
    ...mapActions('alertsSample', [
      'deleteAlertReport',
      'setShowReportPopup',
      'setReportFocusedRowKey',
    ]),
  },
};
</script>
